import { mapActions, mapGetters, mapMutations } from "vuex";

import { email, maxLength, minLength, required } from "vuelidate/lib/validators";
import validation from "@/mixins/validation";

export default {
  name: "login",
  data() {
    return {
      payload: {
        email: this.$route.query.email ? this.$route.query.email : "",
        password: "",
      },
      validationErrors: {},
      showPassword: false,
      emailRules: {
        require: true,
      },
      passwordRules: {
        minLength: 8,
        require: true,
      },
      inputRefs: [],
    };
  },
  mixins: [validation],
  validations() {
    const payload = {
      email: {
        required,
        maxLength: maxLength(120),
      },
      password: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(120),
      },
    }

    if (this.isValidEmail) {
      payload.email['email'] = email
    }

    return { payload };
  },
  computed: {
    ...mapGetters({
      loadingSingIn: "auth/loadingSingIn",
    }),
    isValidPhoneNumber() {
      if (!this.payload || !this.payload.email) {
        return false;
      }
      const cleaned = this.payload.email.trim().replace(/\D/g, '');
      const phoneRegex = /^\d{9,15}$/;
      return phoneRegex.test(cleaned.trim());
    },
    isValidEmail() {
      if (!this.payload || !this.payload.email) {
        return false;
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(this.payload.email);
    },
    passwordErrors() {
      return this.computeErrors("payload", "password", {
        maxLength: { message: "validationMax", count: 120 },
        minLength: { message: "validationMin", count: 8 },
        required: "validationRequired",
      });
    },
    emailErrors() {
      let validators = {
        maxLength: { message: "validationMax", count: 120 },
        required: "validationRequired",
      };

      if (this.isValidEmail) {
        validators = {
          ...validators,
          email: "validationEmail",
        }
      }

      return this.computeErrors("payload", "email", validators);
    },
  },
  created() {
    document.getElementById("html").classList.add("hide");
  },
  methods: {
    ...mapMutations({
      changeRegistrationPopup: "popups/CHANGE_REGISTRATION_POPUP",
      changeLoginPopup: "popups/CHANGE_LOGIN_POPUP",
      changeLoginManagerPopup: "popups/CHANGE_LOGIN_MANAGER_POPUP",
      changeRegisterAgentPopup: "auth/SHOW_AGENT_REGISTER_POPUP",
      changeResetPopup: "popups/CHANGE_RESET_POPUP",
    }),
    ...mapActions({
      login: "auth/GET_TOKEN",
      fetchUser: "profile/FETCH_USER_DATA",
      getFavorites: "favorites/GET_FAVORITES_LIST",
      fetchHeaderMenu: "setting/GET_HEADER_MENU",
    }),
    setItemRef(el) {
      if (el) {
        this.inputRefs.push(el);
      }
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      try {
        const localPayload = { ...this.payload } ;
        if (this.isValidPhoneNumber) {
          localPayload.email = `+${this.payload.email.replace(/\D/g, '')}`;
        }
        await this.login(localPayload).then(() => {
          this.fetchUser().then(() => this.fetchHeaderMenu());
          this.getFavorites();
        });

        this.$toasted.success(this.$t("successLogin"));
        this.changeLoginPopup(false);

        this.$router.nav;

        fbq('track', 'sign_in');
        window.dataLayer.push({
          'event' : 'sign_in',
          'eventCategory' : 'sign_in',
          'eventAction' : 'sign_in',
          'loginMethod' : 'email'
        });
      } catch (error) {
        const message = error.data?.message;
        if (message) {
          this.$toasted.error(message);
        }
      }
    },
    changePopup() {
      this.changeRegistrationPopup(true);
      this.changeLoginPopup(false);
    },
  },
};
